import React from 'react';
import {
  VStack,
  HStack,
  SkeletonCircle,
  Skeleton,
} from '@wegroup/design-system';

const ToolbarMobileLoading: React.FC<React.PropsWithChildren<unknown>> = () => {
  return (
    <VStack
      align="stretch"
      height="98px"
      p="4"
      background="primary.50"
      spacing="4"
    >
      <HStack justifyContent="flex-start">
        <SkeletonCircle size="10" mr="4" />
        <VStack alignItems="flex-start" flexGrow={1}>
          <Skeleton w="50%" height="15px" mr="2" />
          <Skeleton w="50%" height="15px" />
        </VStack>
        <SkeletonCircle size="10" />
        <SkeletonCircle size="10" />
      </HStack>
      <Skeleton height="8px" />
    </VStack>
  );
};

export default ToolbarMobileLoading;
